<!-- 
component: DatePicker.vue
author: Takumi Ogura
description: 日付入力フォーム
repletion: 返却値はYYYY/MM-DD形式の文字列
-->
<template>
	<v-menu
		v-model="menu"
		:close-on-content-click="false"
		:nudge-right="40"
		transition="scale-transition"
		offset-y
		min-width="auto"
		:tabindex="tabIdx"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				ref="textField"
				id="dateField"
				type="date"
				solo
				v-model="pickerText"
				label="年月日"
				clearable
				@click:clear="clear()"
				@keyup="inputDate()"
				hide-details
				v-bind="attrs"
				v-on="on"
				:tabindex="tabIdx + 1"
				:background-color="active ? 'grey lighten-1' : ''"
				:disabled="active"
			>
			</v-text-field>
		</template>
		<v-date-picker
			v-model="picker"
			scrollable
			no-title
			@input="formatDate(picker)"
			locale="jp-ja"
			:day-format="date => new Date(date).getDate()"
			class="datepicker"
			:min="minValue"
			:disabled="active"
		></v-date-picker>
	</v-menu>
</template>
<script>
import Const from '../common/constants.js'
export default {
	props:{
		tabIdx:{
			type: Number,
			default: -1,
		},
		active:{
			type: Boolean,
			default: false,
		}
	},
	data(){
		return {
			menu: false,
			picker: '',
			pickerText: '',
			minValue: Const.datepickerMinValue,
		}
	},
	mounted(){
	},
	computed: {
	},
	methods: {
		// テキストボックスからデートピッカーへ値を挿入
		inputDate() {
			if(!this.pickerText) return null
			let [year, month, day] = this.pickerText.split('-');
			month = ('00' + month).slice(-2);
			day = ('00' + day).slice(-2);
			this.picker = `${year}-${month}-${day}`;
			this.menu = false;
			this.$emit('input', this.picker);
		},
		// デートピッカーからテキストボックスへ値を挿入
		formatDate (date) {
			if (!date) return null
			const [year, month, day] = date.split('-');
//			const wareki = this.convertToWareki(year);
//			const warekiYear = parseInt(year) - wareki.startYear + 1;
//			this.pickerText = `${wareki.era}${warekiYear}年${month}月${day}日`;
//			const [year, month, day] = date.split('-')
			this.pickerText = `${year}-${month}-${day}`;
			this.menu = false;
			this.$emit('input',this.pickerText);
		},
		convertToWareki(year) {
			// 令和：2019年5月1日以降
			if (year >= 2019) {
				return { era: '令和', startYear: 2019 };
			} else if (year >= 1989) {
				return { era: '平成', startYear: 1989 };
			} else if (year >= 1926) {
				return { era: '昭和', startYear: 1926 };
			} else if (year >= 1912) {
				return { era: '大正', startYear: 1912 };
			} else {
				return { era: '明治', startYear: 1868 };
			}
		},
		clear() {
			this.picker = null;
			this.$attrs.value = null;
			this.$emit('clear', '');
		}
	}
}
</script>
<style>
.datepicker {
	height: 375px;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
}
</style>